import React from 'react'
import { Col, Container, Row, Button } from 'react-bootstrap'
import { IoIosArrowBack, BiRightArrowAlt } from 'react-icons/all'
import { useNavigate } from 'react-router-dom';

import './withdraw_styles/withdraw_head.css'

export default function Withdraw_head() {

  const navigate = useNavigate();

  return (
    <>
    <div className='withdraw'>
      <Container>
        <Row>
        <Col className="">
              <div className="withdraw_content d-flex gap-3 align-items-center" onClick={()=>{ navigate(-1)}} style={{ cursor: 'pointer' }}>
                <i className="" style={{fontSize:'1.8rem'}}>
                  <IoIosArrowBack />
                </i>
                <h3 className='m-0'>Digital Currency Withdrawl</h3>
              </div>
            </Col>  
        </Row>
      </Container>
    </div>
    </>
  )
}
